import * as a from '@actions/fitnessAnalytics';

const initial = {
  data: [],
};

const fitnessAnalytics = (state = initial, action = null) => {
  switch (action.type) {
    case a.INITIALIZE_FITNESS_ANALYTICS:
      return initial;
    case a.SET_FITNESS_ANALYTICS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    default:
      return state;
  }
};

export default fitnessAnalytics;
